/**
 * Entry point — boots the console shell into #app.
 */
import "./styles/global.css";
import { renderApp } from "./App";

const root = document.getElementById("app");
if (!root) throw new Error("No #app root in DOM");
renderApp(root);
